import React, { Component } from "react";
import { Accessor, ColorX, GFunc, LocaleX, ResponsiveX, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XDiv, XImage, XText } from "IZOX/_X";
// import GoogleMapReact from "google-map-react";
// import { APIKeys } from "__SYSDefault/APIKeys";
// import MapFlag from "../_parts/MapFlag";
import { observer } from "mobx-react";
import _ from "lodash";
import { QForm } from "IZOX/BLOCKS/Libs";
import { QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import Styles from "__SYSDefault/Styles";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class MapForm extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {
      formValue: {}
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(MapForm.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  onMountQForm = (callbacks) => {
    this.MountQForm = callbacks;
  }

  renderMap(){
    let {info} = this.props;
    if(!info) return;
    // let {lat, lng} = info?.location ?? {};

    return (
      <HStack width={523} height={528} position="relative">
        <XDiv bgColor={ColorX.CSS("Leaf")} width={199} height={199} 
          position="absolute" style={{top: 0, left: 0}}/>
        <XDiv width={507} height={512} 
          position="absolute" style={{top: 16, left: 16}}>
            <XImage source={"/Images/home/map.png"} width={507} height={512}/>
          {/* <GoogleMapReact
            bootstrapURLKeys={{key: APIKeys.GoogleMap}}
            defaultZoom={15}
            defaultCenter={{
              lat: lat ?? 22.319559,
              lng: lng ?? 114.175147
            }}
          >
            <MapFlag
              lat={lat ?? 22.319559}
              lng={lng ?? 114.175147}
              />
          </GoogleMapReact> */}
        </XDiv>
      </HStack> 
    );
  }

  _onSubmit = async () => {
    let {formValue} = this.state;

    if(!ZValidate.Check(formValue?.email, ["email"])){
      GFunc.Alert({
        EN: "Please enter valid email.",
        TC: "請輸入有效電郵地址"
      }, "error");
      return;
    }

    if(!ZValidate.CheckAllFields(formValue, ["name", "email"], "required")){
      GFunc.Alert({
        EN: "Please fill in necessary fields.",
        TC: "請填寫必填欄位。"
      }, "error");
      return;
    }
    
    let res = await APIExpress.PublicMessages.SubmitForm(formValue);
    if(res.Success){
      this.MountQForm.Clear({zip: "+852"});
      
      GFunc.Alert(LocaleX.Parse({
        EN: "Successfully Submitted",
        TC: "成功上傳"
      }), "success");
    }else{
      GFunc.Alert(LocaleX.Parse({
        EN: "Network problem. Please try again later.",
        TC: "網絡不穩定，請稍後再試。"
      }), "warn");
    }
  }

  _onFormChange = (formValue) => {
    this.setState({
      formValue: formValue
    });
  }

  renderField(label, placeholder, name, required){
    return (
      <VStack fullWidth>
        <HStack HAlign="[" spacing={5}>
          <XText fontSize={12}>
            {LocaleX.Parse(label)}
          </XText>
          {required && 
            <XText color={ColorX.CSS("Blood")} fontSize={12}>
              {"*"}
            </XText>}
        </HStack>
        <QFText 
          {...Styles.QFText}
          placeholder={LocaleX.Parse(placeholder)}
          name={name}/>
      </VStack>
    );
  }

  renderForm(){
    let {formValue} = this.state;
    let name = Accessor.Get(formValue, "name");
    let email = Accessor.Get(formValue, "email");
    let isFormValid = !_.isEmpty(name)
      && ZValidate.Check(email, ["required", "email"]);
    return (
      <QForm width={631} HAlign="[" pH={40} pV={40} height={518} spacing={18} 
        onChange={this._onFormChange} onMounted={this.onMountQForm}>
        <XText fontSize={22} color={ColorX.CSS("Grass")} bold>
          {LocaleX.Parse({
            EN: "Contact Us",
            TC: "聯絡我們"
          })}
        </XText>
        {this.renderField({
            EN: "Name",
            TC: "姓名"
          }, {
            EN: "Enter your name",
            TC: "輸入你的姓名"
          },"name", true)}
        {this.renderField({
            EN: "Email address",
            TC: "電郵地址"
          }, {
            EN: "Enter your email",
            TC: "輸入你的電郵"
          },"email", true)}
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12}>
              {LocaleX.Parse({
                EN: "Mobile number",
                TC: "手機號碼"
              })}
            </XText>
          </HStack>
          <HStack fullWidth spacing={13} p={1}>
            <QFText 
              {...Styles.QFText}
              name="zip"
              textAlign="|"
              width={104}
              defaultValue={"+852"} readOnly/>
            <QFText fontSize={14} p={12}
              {...Styles.QFText}
              name="mobile"
              width={104}
              placeholder={LocaleX.Parse({
                EN: "Enter your mobile phone no.",
                TC: "輸入你的電話號碼"
              })}
              fullWidth/>
          </HStack>
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12}>
              {LocaleX.Parse({
                EN: "Leave message",
                TC: "留言"
              })}
            </XText>
          </HStack>
            <QFText 
              {...Styles.QFText}
              name="message"
              placeholder={LocaleX.Parse({
                EN: "Leave a message for us...",
                TC: "給我們一個留言"
                })}
              height={64}
              numberOfLines={4}/>
        </VStack>
        <HStack>
          <XButton 
            {...Styles.QFBtn}
            disabled={!isFormValid}
            width={200}
            onPress={this._onSubmit}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Submit",
                  TC: "提交"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </QForm>
    );
  }

  renderNormal(){
    return (
      <HStack pV={80} spacing={124}>
        {this.renderMap()}
        {this.renderForm()}
      </HStack>
    );
  }

  renderMapM(){
    let {info} = this.props;
    if(!info) return;
    // let {lat, lng} = info?.location ?? {};

    return (
      <HStack fullWidth position="relative">
        <XDiv bgColor={ColorX.CSS("Leaf")} width={199} height={130} 
          position="absolute" style={{top: 0, left: 0}}/>
        <XDiv fullWidth 
          position="relative" style={{top: 16, left: 16}}>
        <XImage source={"/Images/home/map.png"} width={"100%"} height={"100%"}/>
          {/* <GoogleMapReact
            bootstrapURLKeys={{key: APIKeys.GoogleMap}}
            defaultZoom={15}
            defaultCenter={{
              lat: lat ?? 22.319559,
              lng: lng ?? 114.175147
            }}
          >
            <MapFlag
              lat={lat ?? 22.319559}
              lng={lng ?? 114.175147}
              />
          </GoogleMapReact> */}
        </XDiv>
      </HStack> 
    );
  }

  renderFormM(){
    let {formValue} = this.state;
    let name = Accessor.Get(formValue, "name");
    let email = Accessor.Get(formValue, "email");
    let isFormValid = !_.isEmpty(name)
      && ZValidate.Check(email, ["required", "email"]);
    return (
      <QForm fullWidth HAlign="[" pH={20} pV={20} height={518} spacing={18}
        shadow  
        onChange={this._onFormChange} onMounted={this.onMountQForm}>
        <XText fontSize={22} color={ColorX.CSS("Grass")} bold>
          {LocaleX.Parse({
            EN: "Contact Us",
            TC: "聯絡我們"
          })}
        </XText>
        {this.renderField({
            EN: "Name",
            TC: "姓名"
          }, {
            EN: "Enter your name",
            TC: "輸入你的姓名"
          },"name", true)}
        {this.renderField({
            EN: "Email address",
            TC: "電郵地址"
          }, {
            EN: "Enter your email",
            TC: "輸入你的電郵"
          },"email", true)}
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12}>
              {LocaleX.Parse({
                EN: "Mobile number",
                TC: "手機號碼"
              })}
            </XText>
          </HStack>
          <HStack fullWidth spacing={13} p={1}>
            <QFText 
              {...Styles.QFText}
              name="zip"
              textAlign="|"
              width={104}
              defaultValue={"+852"} readOnly/>
            <QFText fontSize={14} p={12}
              {...Styles.QFText}
              name="mobile"
              width={104}
              placeholder={LocaleX.Parse({
                EN: "Enter your mobile phone no.",
                TC: "輸入你的電話號碼"
              })}
              fullWidth/>
          </HStack>
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12}>
              {LocaleX.Parse({
                EN: "Leave message",
                TC: "留言"
              })}
            </XText>
          </HStack>
            <QFText 
              {...Styles.QFText}
              name="message"
              placeholder={LocaleX.Parse({
                EN: "Leave a message for us...",
                TC: "給我們一個留言"
                })}
              height={64}
              numberOfLines={4}/>
        </VStack>
        <HStack>
          <XButton 
            {...Styles.QFBtn}
            disabled={!isFormValid}
            fullWidth
            onPress={this._onSubmit}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Submit",
                  TC: "提交"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </QForm>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth pH={40} spacing={40}>
        {this.renderFormM()}
        {this.renderMapM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default observer(MapForm);
